import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDefaultBudget } from '../hooks/useBudgetQueries';

export const RootRedirect: React.FC = () => {
  const { data: budget, isLoading } = useDefaultBudget();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-32 w-32 animate-spin rounded-full border-b-2 border-indigo-500" />
      </div>
    );
  }

  // If the user has at least one budget, redirect to dashboard
  // Otherwise, redirect to the landing page
  if (budget && budget.id) {
    return <Navigate to="/budgets/current" replace />;
  } else {
    return <Navigate to="/landing" replace />;
  }
};
